import { isMobile, onChange as onBreakpointChange } from '../2-utilities/breakpoint';
import { publish } from '../2-utilities/event';
import {
    FILTER_OPENED
} from '../3-data/consts/eventNames';

const moduleName = 'filter-dialog',
    baseSelector = `.js-${moduleName}`,
    shimSelector = `${baseSelector}-shim`,
    closeSelector = `${baseSelector}-close`,
    hiddenClassName = '--hide';

function closeDialog() {
    const dialog = document.querySelector(baseSelector),
        shim = document.querySelector(shimSelector);

    dialog.classList.add(hiddenClassName);
    shim.classList.add(hiddenClassName);
}

function openDialog() {
    const dialog = document.querySelector(baseSelector),
        shim = document.querySelector(shimSelector);

    dialog.classList.remove(hiddenClassName);
    shim.classList.remove(hiddenClassName);

    publish(FILTER_OPENED);
}

function init() {
    if (isMobile) {
        const toggle = document.querySelector('.js-filter-container-toggle'),
            closeButton = document.querySelector(closeSelector),
            shim = document.querySelector(shimSelector);

        toggle.addEventListener('click', openDialog);
        closeButton.addEventListener('click', closeDialog);
        shim.addEventListener('click', closeDialog);
    }
}

init();
onBreakpointChange(init);
